
import { useRef, useState, useEffect } from "react"

import miguel from "../../../assets/general_assets/testeinstrutor Miguel .jpg"
import ricardinho from "../../../assets/general_assets/ricardinho.jpg"
import cassiano from "../../../assets/general_assets/cassiano.jpg"
import elibraz from "../../../assets/general_assets/elibraz.jpg"

export default function SecTeacherRender() {

    const [currentIndex, setCurrentIndex] = useState(0)
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 450);

    const miguelRef = useRef(null)
    const ricardinhoRef = useRef(null)
    const elibrazRef = useRef(null)
    const cassianoRef = useRef(null)

    const secTeacherCards = [
        {
            nome: "Eli Braz",
            card: elibraz,
            referencia: elibrazRef,
        },
        
        {
            nome: "Cassiano",
            card: cassiano,
            referencia: cassianoRef,
        },
        
        {
            nome: "Miguel",
            card: miguel,
            referencia: miguelRef,
        },

        {
            nome: "Ricardinho",
            card: ricardinho,
            referencia: ricardinhoRef,
        }
        
    ]

    const showCard = (index) => {
        setCurrentIndex(index);
    };


    function nextImg() {
        const newIndex = (currentIndex + 1) % secTeacherCards.length
        showCard(newIndex);

    }

    function prevImg() {
        const newIndex = (currentIndex - 1 + secTeacherCards.length) % secTeacherCards.length
        showCard(newIndex);
    }

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 450);
        };

        window.addEventListener("resize", handleResize);

        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <>

            {isMobile ? (

                <div className="main_teachers">
                    {secTeacherCards.map((secTeacher, index) => (

                        <div key={index} ref={(el) => secTeacher.referencia = el} className={`sub_teacher_card ${index === currentIndex ? "active" : ""}`}>

                            <i onClick={prevImg} id="teacher-img_left" class="bi bi-chevron-left"></i>
                            <i onClick={nextImg} id="teacher-img_right" class="bi bi-chevron-right"></i>
                            <img src={secTeacher.card} alt="Imagem Professor Team Crezio" loading="lazy"></img>
                            <p className="sub_teacher_card_name">{secTeacher.nome}</p>

                        </div>


                    ))}
                </div>

            ) : (
                <div className="main_teachers">
                    {secTeacherCards.map((secTeacher) => (

                        <div ref={secTeacher.referencia} className="sub_teacher_card">

                            <img src={secTeacher.card} alt="Imagem Professor Team Crezio" loading="lazy"></img>
                            <p className="sub_teacher_card_name">{secTeacher.nome}</p>

                        </div>


                    ))}
                </div>
            )

            }
        </>
    )
}
